import { createPlugin } from './pm-plugins/main';
var pastePlugin = function pastePlugin(_ref) {
  var _api$featureFlags;
  var config = _ref.config,
    api = _ref.api;
  var _ref2 = config !== null && config !== void 0 ? config : {},
    cardOptions = _ref2.cardOptions,
    sanitizePrivateContent = _ref2.sanitizePrivateContent;
  var featureFlags = (api === null || api === void 0 ? void 0 : (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
  return {
    name: 'paste',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'paste',
        plugin: function plugin(_ref3) {
          var schema = _ref3.schema,
            providerFactory = _ref3.providerFactory,
            dispatchAnalyticsEvent = _ref3.dispatchAnalyticsEvent,
            dispatch = _ref3.dispatch;
          return createPlugin(schema, dispatchAnalyticsEvent, dispatch, featureFlags, api, cardOptions, sanitizePrivateContent, providerFactory);
        }
      }];
    }
  };
};
export default pastePlugin;